<template>
  <div class="freegoods-container">
    <div class="banner">
      <div class="amount">
        <span class="label">额度</span>
        <span class="prefix">¥</span>
        <span class="value">{{ targetPrice }}</span>
      </div>
      <div class="btn" @click="bannerBtnClick">选择商品送额度免费抢</div>
    </div>
    <div class="content">
      <template v-for="item in data">
        <Panel :data="item" :key="item.actThemeId" :targetPrice="targetPrice" />
      </template>
    </div>
  </div>
</template>

<script>
import Panel from './components/Panel'
import { getFreeGoodsList, getTargetPrice } from '@/api/freeGoods'
export default {
  components: { Panel },
  data() {
    return {
      targetPrice: null,
      data: [],
    }
  },
  created() {
    this.getTargetPrice()
    this.getData()
  },
  methods: {
    getTargetPrice() {
      getTargetPrice().then((res) => {
        this.targetPrice = res.data
      })
    },
    getData() {
      this.$store.dispatch('app/showLoading')
      getFreeGoodsList()
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          this.data = res.data
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
      // this.data = [
      //   {
      //     id: 1,
      //     title: '选择好货',
      //     list: [{}, {}, {}, {}],
      //   },
      // ]
    },
    bannerBtnClick() {
      document.documentElement.scrollTop =
        document.querySelector('.freegoods-container .content').offsetTop -
        document.querySelector('.freegoods-container .custom-head').offsetHeight
    },
  },
}
</script>

<style lang="less" scoped>
.freegoods-container {
  min-height: 100%;
  padding-top: 100px;
  background-color: #f07e3c;
  .banner {
    position: relative;
    height: 707px;
    background-image: url('~@/assets/activityplace/免费抢好货.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-top: 280px;
    .amount {
      text-align: center;
      color: #e82035;
      height: 84px;
      .label {
        font-size: 46px;
        line-height: 1em;
      }
      .prefix {
        font-size: 72px;
        line-height: 1em;
        font-weight: 600;
        margin-left: 8px;
      }
      .value {
        font-size: 84px;
        line-height: 1em;
        font-weight: 600;
        margin-left: 4px;
      }
    }
    .btn {
      position: absolute;
      left: 50%;
      margin-left: -229px;
      bottom: 130px;
      width: 458px;
      text-align: center;
      padding: 15px 0;
      background: #ffd768;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.28);
      border-radius: 6px;
      font-size: 24px;
      font-weight: 600;
      color: #d21428;
      line-height: 34px;
    }
  }
  .content {
    min-height: calc(~'100vh - 807px');
    padding-bottom: 80px;
    background: linear-gradient(180deg, #f7c267 0%, #ee7c37 100%);
  }
}
</style>
